import React, { useState } from "react";
import Logo from "../../src/assetes/logo.png";
import { Button, Modal, Input, DatePicker, Select, InputNumber } from "antd";
const Footer = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const { TextArea } = Input;

  const [fName, setFName] = useState("");
  const [mName, setMName] = useState("");
  const [lName, setLName] = useState("");

  const [email, setEmail] = useState("");
  const [mob, setMob] = useState("");
  const [interest, setInterest] = useState("");

  const [dob, setDob] = useState("");
  const [edu, setEdu] = useState("");
  const [dropdown, setDropdown] = useState("");
  const [addr, setAddr] = useState("");
  const [msg, setMsg] = useState("");
  const [other, setOther] = useState("");

  const [showOther, setShowOther] = useState(false);

  const handleFormClose = () => {
    setIsFormOpen(false);
  };

  const onDateChange = (date, dateString) => {
    setDob(dateString);
  };

  const onInterestChange = (e) => {
    console.log(e);
    if (e == "अन्य") {
      setShowOther(true);
    } else {
      setShowOther(false);
    }

    setInterest(e);
  };

  const submitForm = async () => {
    if (fName == "" && mName == "" && lName == "" && mob == "") {
      alert("Please Enter data in required fields");
      return;
    }

    const body = {
      firstName: fName,
      middleName: mName,
      lastName: lName,
      emailId: email,
      mobileExt: "+91",
      mobileNumber: mob,
      message: msg,
      address: addr,
      dob: dob,
      education: edu,
      subOfInterest: interest,
      otherText: other,
    };

    const url = "https://flintinfotech.com/shree/addData";

    const data = await fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: new Headers({
        "content-type": "application/json",
      }),
    });

    const res = await data.json();
    if (res.statusCodeValue === 200) {
      alert("Registration Successfull");
      handleFormClose();
    }
  };

  return (
    <div className="mt-5 py-10 px-5 bg-blue-100/80 font-sans dark:bg-gray-900">
      <div className="sm:flex sm:justify-between items-center ">
        <div className="flex justify-center items-center">
          <img src={Logo} className="w-52" />
        </div>
        <div className="text-2xl text-center mt-10 sm:mt-0">
          नाद हिंदवी स्वराज्याचा वारसा दुर्ग संवर्धनाचा
        </div>
        <div className="text-center sm:text-start">
          <label className="text-center w-full">Address</label>
          <p className="text-gray-600  dark:text-gray-300  hover:text-blue-500">
            {" "}
            Mundhe floor mill, near Gune hospital <br /> line ali , panvel:-
            410206
          </p>
          <p className="text-gray-600  dark:text-gray-300  hover:text-blue-500">
            Narendra chachad - 8454843450 <br />
            Pratik chachad - 7303644823
          </p>
          <p className="text-gray-600  dark:text-gray-300  hover:text-blue-500">
            Email - shreeshivsahyadrisanstha12@gmail.com
          </p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-[80%]">
          <p className="font-sans p-8 text-start md:text-center md:text-sm md:p-4">
            © 2024 श्री शिव सह्याद्री संस्था, महाराष्ट्र राज्य All rights
            reserved.
          </p>
        </div>

        <div className="flex gap-4 hover:cursor-pointer w-[20%] justify-end pr-5">
          <a
            href="https://www.facebook.com/profile.php?id=100064423553126&mibextid=ZbWKwL"
            target="_blank"
          >
            <img
              src="https://www.svgrepo.com/show/303114/facebook-3-logo.svg"
              width="30"
              height="30"
              alt="fb"
            />
          </a>

          <a
            href="https://www.instagram.com/shreeshivsahyadrimaharashtra?igsh=MW9uMTdtNzRqbjI5dw=="
            target="_blank"
          >
            <img
              src="https://www.svgrepo.com/show/303145/instagram-2-1-logo.svg"
              width="30"
              height="30"
              alt="inst"
            />
          </a>

          <Button
            className="sm:block hidden"
            onClick={() => setIsFormOpen(!isFormOpen)}
          >
            Join Us
          </Button>

          <Button
            type="primary"
            className="sm:hidden block fixed bottom-10 right-8"
            onClick={() => setIsFormOpen(!isFormOpen)}
          >
            Join Us
          </Button>
        </div>

        <Modal
          title="श्री शिवसह्याद्री संस्थेचे सभासद होण्यासाठी पुधील महिती भरावी"
          open={isFormOpen}
          onCancel={handleFormClose}
          footer={null}
          width="70%"
        >
          <div className="sm:flex gap-10 mt-10">
            <div className="flex flex-col w-full">
              <label>First Name*</label>
              <Input
                placeholder="First Name"
                value={fName}
                onChange={(e) => setFName(e.target.value)}
                className="mt-5 sm:mt-0"
              />
            </div>

            <div className="flex flex-col w-full">
              <label>Middle Name*</label>
              <Input
                placeholder="Middle Name"
                value={mName}
                onChange={(e) => setMName(e.target.value)}
                className="mt-5 sm:mt-0"
              />
            </div>

            <div className="flex flex-col w-full">
              <label>Last Name*</label>
              <Input
                placeholder="Last Name"
                value={lName}
                onChange={(e) => setLName(e.target.value)}
                className="mt-5 sm:mt-0"
              />
            </div>
          </div>

          <div className="sm:flex gap-10 mt-10">
            <div className="flex flex-col w-full">
              <label>Email</label>
              <Input
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="sm:w-[100%] mt-0 sm:mt-0"
              />
            </div>

            <div className="flex flex-col w-full">
              <label>Mobile Number*</label>
              <InputNumber
                placeholder="Mobile Number"
                onChange={(e) => setMob(e.target.value)}
                value={mob}
                className="sm:w-[100%] w-full mt-5 sm:mt-0"
              />
            </div>

            <div className="flex flex-col w-full">
              <label>Date of Birth</label>
              <DatePicker
                format="MM-DD-YYYY"
                onChange={onDateChange}
                className="sm:w-[100%] w-full mt-5 sm:mt-0"
              />
            </div>
          </div>

          <div className="sm:flex gap-10 mt-10">
            <div className="flex flex-col w-full">
              <label>Education</label>
              <Input
                placeholder="Education"
                value={edu}
                onChange={(e) => setEdu(e.target.value)}
                className="sm:w-[100%] w-full mt-0 sm:mt-0"
              />
            </div>

            <div className="flex flex-col w-full">
              <label>Area of Interest</label>
              <Select
                className="sm:w-[100%] w-full mt-5 sm:mt-0"
                placeholder="Please select Area of Interest"
                defaultValue=""
                onChange={(e) => {
                  onInterestChange(e);
                }}
                options={[
                  { value: "कला", label: "कला" },
                  { value: "क्रीडा", label: "क्रीडा" },
                  { value: "संस्कृती", label: "संस्कृती" },
                  { value: "शैक्षणिक", label: "शैक्षणिक" },
                  { value: "अन्य", label: "अन्य" },
                  { value: "दुर्गसंवर्धन", label: "दुर्गसंवर्धन" },
                  { value: "सामाजिक", label: "सामाजिक" },
                ]}
              />
            </div>
          </div>

          <div className="mt-10">
            {showOther && (
              <div className="flex flex-col w-full">
                <label>Other</label>
                <TextArea
                  rows={3}
                  value={other}
                  placeholder="Other"
                  onChange={(e) => setOther(e.target.value)}
                />
              </div>
            )}
          </div>

          <div className="mt-10">
            <div className="flex flex-col w-full">
              <label>Address</label>
              <TextArea
                rows={3}
                value={addr}
                onChange={(e) => setAddr(e.target.value)}
                placeholder="Address"
              />
            </div>
          </div>

          <div className="mt-10">
            <div className="flex flex-col w-full">
              <label>Message</label>
              <TextArea
                rows={3}
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                placeholder="Message"
              />
            </div>
          </div>

          <div className="mt-5">
            <Button type="primary" onClick={() => submitForm()}>
              Submit
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Footer;
